import { navLinks } from '@/mocks/home';

const footerColumns = [
  {
    title: "浏览",
    links: ["今日热帖", "爆料帖专区", "精华热榜", "最新回复", "讨论区"],
  },
  {
    title: "社区",
    links: ["发帖规范", "举报与申诉", "社区公约", "志愿者招募", "免责声明"],
  },
  {
    title: "客户端",
    links: ["客户端下载", "更新日志", "桌面推送设置", "离线存档说明", "反馈建议"],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-200 bg-secondary-950 text-secondary-100">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-950">
                <i className="ri-newspaper-line text-2xl" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">黑料社区</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-secondary-200">
              黑料社区聚集今日热帖与爆料帖，精华帖按热度排序，最新回复实时滚动，讨论区支持跟帖、反驳与补充线索，帮你快速跟上事件进展。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-tiktok-line', 'ri-mail-line'].map((icon) => (
                <button
                  key={icon}
                  type="button"
                  aria-label="社交渠道"
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-secondary-800 text-secondary-200 transition-colors hover:border-secondary-600 hover:text-background-50"
                >
                  <i className={`${icon} text-lg`} />
                </button>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">{column.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="whitespace-nowrap text-sm text-secondary-200 transition-colors hover:text-background-50"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-secondary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-secondary-300">
            © 2026 黑料社区 · 内容由网友自发发布，请理性围观
          </p>
          <nav className="flex flex-wrap items-center gap-x-5 gap-y-2" aria-label="页脚导航">
            {navLinks.slice(0, 4).map((link) => (
              <a key={link.label} href={link.href} className="text-xs text-secondary-300 transition-colors hover:text-background-50">
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}